import React, { createContext, useContext, useState, useRef, useLayoutEffect, } from 'react';
const FilterSearchContext = createContext(null);
// Inline filter components remount when the table refreshes; keep the query in the panel.
export const FilterSearchProvider = (props) => {
    const state = useState('');
    const container = useRef(null);
    const initialized = useRef(false);
    const focusedKey = useRef(null);
    useLayoutEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            container.current
                ?.querySelector('input[type="search"]')
                ?.focus();
            return;
        }
        if (document.activeElement !== document.body) {
            return;
        }
        const control = focusedKey.current === 'search'
            ? container.current?.querySelector('input[type="search"]')
            : [
                ...(container.current?.querySelectorAll('[data-filter-focus]') ?? []),
            ].find((element) => element.dataset.filterFocus === focusedKey.current);
        const focusTarget = control?.querySelector('input') ?? control;
        focusTarget?.focus();
    });
    return (React.createElement(FilterSearchContext.Provider, { value: state },
        React.createElement("div", { ref: container, onFocusCapture: (event) => {
                focusedKey.current =
                    event.target.closest('[data-filter-focus]')?.dataset
                        .filterFocus ??
                        (event.target.matches('input[type="search"]') ? 'search' : null);
            } }, props.children)));
};
export const useFilterSearch = () => {
    const panel = useContext(FilterSearchContext);
    const local = useState('');
    return panel ?? local;
};
//# sourceMappingURL=FilterSearch.js.map